/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/field_extract.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Extracts the value of a single sub-field from a `flattened` field root as `keyword`.',
  examples: [
    'FROM flattened_otel_logs\n| WHERE @timestamp == "2020-01-01T00:02:48.461Z"\n| EVAL hn = field_extract(resource.attributes, "host.name")\n| KEEP hn',
  ],
  params: {
    field: 'The root of a `flattened` mapping field. If `null`, the function returns `null`.',
    path: 'Literal name of the flattened sub-field to extract (e.g. `"host.name"`). Brackets and array indices are not supported. If `null`, the function returns `null`.',
  },
};

export default docs;
